import axios from "axios";
import Config from "src/config";

const v2_actionDeleteFlowDirect = (flowDirectId) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${flowDirectId}/delete-flow-direct`
    });
};

export default v2_actionDeleteFlowDirect;
